import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Icon from '../../atoms/Icon'
import { useFormattingContext } from '../../organisms/FormattingProvider/FormattingContext'

/**
 * Represents an individual activity item that should look like a "task"
 * @param activity
 * @param onClick
 * @param className
 * @param style
 * @param includeDueDate - whether to include the due date below the subject
 * @returns {JSX.Element}
 * @constructor
 */
function TaskActivity ({ activity, onClick, className, includeDueDate, style }) {
  const { formatter } = useFormattingContext()
  return (
    <div className={clsx(className, 'flex flex-row gap-sm clickable')} style={style} onClick={onClick}>
      <div>
        <Icon
          name={activity.completed ? 'checkCircle' : 'clock'}
          style={{ fill: activity.completed ? 'var(--color-success-500)' : 'var(--color-warning-500)' }}
          customSize={20}
        />
      </div>
      <div className='flex flex-col gap-xs'>
        <span>{activity.subject}</span>
        {includeDueDate && activity.endDate && (
          <span className='font-size-xs text-neutral-500'>
            Due {formatter(activity.endDate, 'date')}
          </span>
        )}
      </div>
    </div>
  )
}

TaskActivity.propTypes = {
  activity: PropTypes.shape({
    subject: PropTypes.string,
    completed: PropTypes.bool,
    endDate: PropTypes.string
  }).isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  includeDueDate: PropTypes.bool,
  style: PropTypes.object
}

export default TaskActivity
